import _ from 'underscore';

import {TieredRadioButtonForm} from './tiered-radio-button-form';

export class FormPhone extends TieredRadioButtonForm {
    getFields = () => {
        const fields = [
            {
                id: 'Starts with',
                value: 'Starts with',
            },
            {
                id: 'Equals',
                value: 'Is exactly',
            },
        ];

        if (this.props.anyOptionText) {
            fields.push({id: 'any', value: this.props.anyOptionText});
        }

        if (this.props.nullOptionText) {
            fields.push({id: 'null', value: this.props.nullOptionText});
        }

        return fields;
    };

    // @ts-expect-error
    onChangeDebounced = _.debounce((data) => {
        if (!data) {
            // Clear out the filter
            this.props.onChange(null);
        } else if (
            data[this.props.name] &&
            data[this.props.name].data &&
            data[this.props.name].data.length >= 3
        ) {
            // Require a minimum of 3 chars before applying filter
            this.props.onChange(data);
        }
    }, 500);
}
